/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ wpm: NonNullable<unknown> }} Event_Ad_Rephrase_To_WpmInputs */



/**
* | output |
* | --- |
* | "Rephrase to {wpm} WPM" |
*
* @param {Event_Ad_Rephrase_To_WpmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_rephrase_to_wpm = /** @type {((inputs: Event_Ad_Rephrase_To_WpmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Rephrase_To_WpmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Reformuler a ${i?.wpm} WPM`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Umformulieren zu ${i?.wpm} WPM`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Riformulare in ${i?.wpm} WPM`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Перефразируйте до ${i?.wpm} слов в минуту`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Reformular a ${i?.wpm} WPM`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`改写为${i?.wpm} WPM`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.wpm} WPMに言い換える`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इसे ${i?.wpm} WPM में पुनः लिखें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Reformule para ${i?.wpm} WPM`)
	return /** @type {LocalizedString} */ (`Rephrase to ${i?.wpm} WPM`)
});